import React, {memo} from 'react';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});
import Link from 'next/link';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import {AnimatedComponent} from '../AnimatedComponent';
import CommonCard from '../home/common-card';
import {CommonImageWrapper} from '../home/home-services';
import {fadeInUp} from '@/animation/scroll-animation';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import {colors, fontSize, fontWeight} from '@/styles/tokens';
import {ICON_TILE_ICON_SIZE} from '@/styles/iconTile';

const tagSx = {
    bgcolor: colors.background.tag,
    borderRadius: '999px',
    px: '14px',
    py: '7px',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0
} as const;

const tagTextSx = {
    fontSize: '14px',
    fontWeight: fontWeight.medium,
    color: colors.primary.link,
    lineHeight: '14px',
    whiteSpace: 'nowrap' as const
} as const;

const TokenizeHelp = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                    <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                        {heading}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="p"
                        className="font-regular-text generative-transforming-subheading"
                        sx={{fontSize: fontSize[16], color: colors.text.primary}}
                    >
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>
                <Box>
                    <Grid container spacing={3} rowSpacing={5}>
                        {contentData?.map((item: any, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={index + 1}>
                                <AnimatedComponent variants={fadeInUp} delay={index * 0.2} className="height-full">
                                    <CommonCard>
                                        <Box display="flex" gap={3} pb={2} alignItems="center">
                                            {item.src ? (
                                                <CommonImageWrapper>
                                                    <DisplayImage
                                                        alt={item.heading}
                                                        src={item.src}
                                                        className="home-service-icon"
                                                        width={ICON_TILE_ICON_SIZE}
                                                        height={ICON_TILE_ICON_SIZE}
                                                    />
                                                </CommonImageWrapper>
                                            ) : null}
                                            {item.redirect ? (
                                                <Typography variant="h3" component="h3" mt={2} mb={2}>
                                                    <Link href={item.redirect} className="card-redirection-heading font-headers ">
                                                        {item.heading}
                                                    </Link>
                                                </Typography>
                                            ) : (
                                                <Typography variant="h3" component="h3" mt={2} mb={2} className="font-headers">
                                                    {item.heading}
                                                </Typography>
                                            )}
                                        </Box>

                                        <Typography
                                            variant="body1"
                                            className="font-regular-text remove-underline"
                                            sx={{fontSize: fontSize[16], color: colors.text.primary}}
                                        >
                                            {item.body ? parse(item.body) : ''}
                                        </Typography>
                                        <Box mt={1}>
                                            {item.content?.map((point: any, subIndex: any) => (
                                                <Box key={subIndex}>
                                                    <Box display="flex" gap={1} mt={1}>
                                                        <Box mt={0.5}>
                                                            <CheckCircleOutlineOutlinedIcon fontSize="small" />
                                                        </Box>
                                                        <Typography
                                                            className="font-regular-text generative-transforming-subheading"
                                                            component="p"
                                                            sx={{fontSize: fontSize[16], color: colors.text.primary}}
                                                        >
                                                            {point ? parse(point) : ''}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                        {item.tags?.length > 0 && (
                                            <Box display="flex" flexWrap="wrap" gap="8px" mt={2}>
                                                {item.tags.map((tag: string) => (
                                                    <Box key={tag} sx={tagSx}>
                                                        <Typography className="font-headers" sx={tagTextSx}>
                                                            {tag}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </CommonCard>
                                </AnimatedComponent>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </MUIContainer>
        </Box>
    );
};
export default memo(TokenizeHelp);
